<nav id="sidebar2" >
    <div class="title" >
        <h4>MENÚ</h4>
    </div>
    <ul class="list-unstyled components mb-5">
        <li
          [routerLinkActive]="['active']"
          #rla="routerLinkActive" >
            <a [routerLink]="'/modulo-seguridad/seguridad'">
              <img src="../../../assets/images/general/folder.png" >&nbsp;&nbsp;&nbsp;&nbsp;Seguridad
            </a>
        </li>
        <div id="sidebar3" *ngIf="rla.isActive">
            <li
              [routerLinkActive]="['active']"
              [routerLinkActiveOptions]="{exact:true}"
              *ngxPermissionsOnly="['crearRol']"
              (click)="selectedtab('creacion-rol')">
                <a
                  style="margin-top: 5px !important;"
                  [routerLink]="'/modulo-seguridad/seguridad/creacion-rol'">
                  <span class="iconsidebar3 icon-oval" style="width: 8px;height: 8px;"></span>&nbsp;&nbsp;&nbsp;&nbsp;Creación de Rol
                </a>
            </li>
            <li
              [routerLinkActive]="['active']"
              [routerLinkActiveOptions]="{exact:true}"
              *ngxPermissionsOnly="['listadoRoles']"
              (click)="selectedtab('listado-roles')">
                <a
                  style="margin-top: 5px !important;"
                  [routerLink]="'/modulo-seguridad/seguridad/listado-roles'">
                  <span class="iconsidebar3 icon-oval" style="width: 8px;height: 8px;"></span>&nbsp;&nbsp;&nbsp;&nbsp;Listado de Roles
                </a>
            </li>
            <li
              [routerLinkActive]="['active']"
              [routerLinkActiveOptions]="{exact:true}"
              *ngxPermissionsOnly="['crearPerfil']"
              (click)="selectedtab('creacion-perfil')">
              <a
                style="margin-top: 5px !important;"
                [routerLink]="'/modulo-seguridad/seguridad/creacion-perfil'">
                <span class="iconsidebar3 icon-oval" style="width: 8px;height: 8px;"></span>&nbsp;&nbsp;&nbsp;&nbsp;Creación de Usuario
              </a>
            </li>
            <li
              [routerLinkActive]="['active']"
              [routerLinkActiveOptions]="{exact:true}"
              *ngxPermissionsOnly="['listarPerfil']"
              (click)="selectedtab('listado-usuarios')">
                <a
                  style="margin-top: 5px !important;"
                  [routerLink]="'/modulo-seguridad/seguridad/listado-usuarios'">
                  <span class="iconsidebar3 icon-oval" style="width: 8px;height: 8px;"></span>&nbsp;&nbsp;&nbsp;&nbsp;Listado de usuarios
                </a>
            </li>
        </div>
       <!-- <li
          [routerLinkActive]="['active']"
          [routerLinkActiveOptions]="{exact:true}">
            <a [routerLink]="'/modulo-seguridad/sib'">
              <img src="../../../assets/images/general/folder.png" >&nbsp;&nbsp;&nbsp;&nbsp;Seguridad SIB
            </a>
        </li>
        <li
          [routerLinkActive]="['active']"
          [routerLinkActiveOptions]="{exact:true}">
            <a
              [routerLink]="'/modulo-seguridad/reportes'">
              <img src="../../../assets/images/general/folder.png" >&nbsp;&nbsp;&nbsp;&nbsp;Reportes
            </a>
        </li>-->
    </ul>
</nav>
